import axios from 'axios'
const state = () => ({
    leader: [],
    leaderDetail: {}
})

const getters = {
    leader(state) {
        return state.leader
    },
    leaderDetail(state) {
        return state.leaderDetail
    }
}

const mutations = {
    GET_LEADER(state, payload){
        state.leader = payload
    },
    GET_LEADER_DETAIL(state, payload){
        state.leaderDetail = payload
    },
}

const actions = {
    getLeader({commit}){
        axios.get(`https://api.geomalaka.uz/api/employee/rahbariyat/`)
            .then((res)=>{
                commit("GET_LEADER", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
    getLeaderById({commit}, id){
        axios.get(`https://api.geomalaka.uz/api/employee/rahbariyat/${id}/`)
            .then((res)=>{
                commit("GET_LEADER_DETAIL", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
